import { Flex, Form, Typography } from 'antd';
import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

export const CleaningScheduleCardContainer = styled.div`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    padding-block: ${kcc.size.S200}px;
    padding-inline: ${kcc.size.S250}px;
    border: ${kcc.lineWidth.BORDER}px solid ${kcc.colors.BORDER_SECONDARY};

    .ant-btn-icon {
      width: ${kcc.size.S250}px;
      height: ${kcc.size.S250}px;

      svg {
        width: ${kcc.size.S250}px;
        height: ${kcc.size.S250}px;
      }
    }
  `}
`;

export const CleaningScheduleCardThumbnailEmpty = styled.div`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    background-color: ${kcc.colors.BG_LAYOUT};

    svg path {
      fill: ${kcc.colors.TEXT_PLACEHOLDER};
    }
  `}
`;

export const CleaningScheduleCardContent = styled(Flex)`
  ${(): FlattenSimpleInterpolation => css`
    flex: 1;
  `}
`;

export const CleaningScheduleCardTitle = styled(Typography.Text)`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    &.ant-typography {
      font-size: ${kcc.typography.FONT_SIZE.LG}px;
      font-weight: ${kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 300px;
      max-width: 80%;
    }
  `}
`;

export const CleaningScheduleCardDescription = styled(Typography.Text)`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    &.ant-typography {
      font-size: ${kcc.typography.FONT_SIZE.SM}px;
      color: ${kcc.colors.TEXT_DESCRIPTION};
    }
  `}
`;

export const CleaningScheduleCardFormItem = styled(Form.Item)`
  margin: 0;
  width: 100%;

  .ant-form-item-explain-error {
    position: absolute;
    margin-top: 2px;
  }

  .ant-segmented-group,
  .ant-segmented-item,
  .ant-segmented-thumb {
    height: 32px;
  }

  .ant-segmented-item-label {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    min-height: unset;
    padding-block: 0;
    line-height: normal;
  }
`;
